import React, { useState } from 'react';

function Reportcontent4({ onNext, onBack }) {
  const [selectAnoymouslyradio, setSelectAnoymouslyradio] = useState('');
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');


  const handleRadioChange = (event) => {
    setSelectAnoymouslyradio(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };


  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };


  const handleNext = async () => {
    if (!selectAnoymouslyradio) {
      setError('Please select whether you want to share your personal information or not.');
    } else if (!email || !isValidEmail(email)) {
      setError('Please enter a valid email address.');
    } else {
      setError(''); // Clear the error
      const data = {
        selectAnoymouslyradio,
        email
      };
      onNext({ data });
    }
  };

  const sendAnonymously = [
    {
      id: 0,
      title: 'Yes'
    },
    {
      id: 1,
      title: 'No'
    }
  ];

  return (
    <div className="r-content">
      <p className="content-text">
        You can submit a report or question anonymously. Anonymous reports or questions will be handled in the same way as those with disclosed reporters.
        If you decide to disclose your information, this will enable a more productive and efficient handling of the report or question. Your information
        will always be treated confidentially. In both cases, you will be given a username and password that will allow you to access your online mailbox
        and securely track your report or question and continue communication.
      </p>
      <br />
      <div className="content-text">Are you ready to share your personal information?</div>
      <form>
        {error && <div className="error" style={{ color: 'red', marginTop: '10px' }}>{error}</div>}
        <div className="abusetestlist">
          {sendAnonymously.map((anonymouslydata) => (

            <label className="reportradiobutton" key={anonymouslydata.id}>
              <p className="checkbox-label" htmlFor={`abuse-${anonymouslydata.id}`}>{anonymouslydata.title}</p>
              <input
                className="custom-radio"
                type="radio"
                id={`abuse-${anonymouslydata.id}`}
                name="abuseType"
                value={anonymouslydata.title}
                checked={selectAnoymouslyradio === anonymouslydata.title}
                onChange={handleRadioChange}
              />
            </label>
          ))}
        </div>
        <div className="fill-opt1 fill-email">
          <p htmlFor="">Enter your email</p>
          <div className="content-text">
            Please enter your email to receive a email and password to view details
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={handleEmailChange}
            required
          />
        </div>
      </form>

      <div className="back-next">
        <button className="Backbtn" onClick={onBack}>Back</button>
        <button className="Nextbtn" onClick={handleNext}>Next</button>
      </div>
    </div>
  );
}

export default Reportcontent4;
